import axios from 'axios';

const api = '/api/druzstvo-appreciations';

export const getAppreciation = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const createAppreciation = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const updateAppreciation = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};
